'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import Button from '../../Button/index.js';
import '../../Images/AddIcon/index.js';
import '../../Images/AddOutlinedIcon/index.js';
import '../../Images/Trash/index.js';
import '../../Images/Pencil/index.js';
import ArrowDownIcon from '../../Images/ArrowDownIcon/index.js';
import '../../Images/ArrowRoundedLeft/index.js';
import '../../Images/ArrowRoundedRight/index.js';
import '../../Images/AwardsIcon/index.js';
import '../../Images/BonusIcon/index.js';
import '../../Images/CanteenIcon/index.js';
import '../../Images/CheckTagIcon/index.js';
import '../../Images/CommercialIcon/index.js';
import '../../Images/CompanySizeIcon/index.js';
import '../../Images/ContactIcon/index.js';
import '../../Images/CopyIcon/index.js';
import '../../Images/DefaultAvatar/index.js';
import '../../Images/DangerIcon/index.js';
import '../../Images/ExternalLinkIcon/index.js';
import '../../Images/FacebookIcon/index.js';
import '../../Images/ForwardIcon/index.js';
import '../../Images/HealthcarePlanIcon/index.js';
import '../../Images/HeartIcon/index.js';
import '../../Images/HeartOutlineIcon/index.js';
import '../../Images/HideIcon/index.js';
import '../../Images/KindergartenIcon/index.js';
import '../../Images/LaptopIcon/index.js';
import '../../Images/LibraryIcon/index.js';
import '../../Images/LinkIcon/index.js';
import '../../Images/LinkedInIcon/index.js';
import '../../Images/LoadingCircleIcon/index.js';
import '../../Images/MarkerIcon/index.js';
import '../../Images/MobileIcon/index.js';
import '../../Images/PaidLeaveIcon/index.js';
import '../../Utils/constants.js';
import SearchIcon from '../../Images/SearchIcon/index.js';
import '../../Images/ShareIcon/index.js';
import '../../Images/ReportIcon/index.js';
import '../../Images/StatsIcon/index.js';
import '../../Images/TeamActivitiesIcon/index.js';
import '../../Images/ThreeDotIcon/index.js';
import '../../Images/TrainingIcon/index.js';
import '../../Images/TransportationIcon/index.js';
import '../../Images/TrashIcon/index.js';
import '../../Images/TravelOpportunitiesIcon/index.js';
import '../../Colors/index.js';
import '../../Images/VerticalMoreIcon/index.js';
import '../../Images/VoucherIcon/index.js';
import '../../Images/WowCVIcon/index.js';
import '../../Images/WorkingLocationIcon/index.js';
import '../../Images/ZaloIcon/index.js';
import '../../Images/FacebookLogoIcon/index.js';
import '../../Images/GoogleLogoIcon/index.js';
import '../../Images/DragReorderIcon/index.js';
import '../../Images/CheckIcon/index.js';
import '../../Images/CircleChecked/index.js';
import '../../Images/SalaryIcon/index.js';
import '../../Images/BriefcaseIcon/index.js';
import '../../Images/GraduationCapIcon/index.js';
import '../../Images/EnvelopeIcon/index.js';
import '../../Images/AddFilledIcon/index.js';
import '../../Images/HomeIcon/index.js';
import '../../Images/PhoneIcon/index.js';
import '../../Images/AttachIcon/index.js';
import '../../Images/FilterIcon/index.js';
import '../../icons/WarnIcon.js';
import '../../icons/AccountSettingsIcon.js';
import '../../icons/DashboardIcon.js';
import '../../icons/JobAlertsIcon.js';
import '../../icons/MyCompaniesIcon.js';
import '../../icons/MyJobsIcon.js';
import '../../icons/MyProfileIcon.js';
import '../../icons/ProfileSettingsIcon.js';
import '../../icons/LanguageIcon.js';
import '../../icons/BenefitGroupIcons/ActivityIcon.js';
import '../../icons/BenefitGroupIcons/AwardsIcon.js';
import '../../icons/BenefitGroupIcons/BonusIcon.js';
import '../../icons/BenefitGroupIcons/CanteenIcon.js';
import '../../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../../icons/BenefitGroupIcons/LaptopIcon.js';
import '../../icons/BenefitGroupIcons/LibraryIcon.js';
import '../../icons/BenefitGroupIcons/MoreIcon.js';
import '../../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../../icons/BenefitGroupIcons/PhoneIcon.js';
import '../../icons/BenefitGroupIcons/TrainingIcon.js';
import '../../icons/BenefitGroupIcons/TransportationIcon.js';
import '../../icons/BenefitGroupIcons/TravelIcon.js';
import '../../icons/BenefitGroupIcons/VoucherIcon.js';
import '../../icons/BenefitGroupIcons/Physics.js';
import '../../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../../icons/AccountCenterGroupIcons/Language.js';
import '../../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../../icons/AccountCenterGroupIcons/Lawyer.js';
import '../../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../../icons/InfoOverviewGroupIcons/Location.js';
import '../../icons/InfoOverviewGroupIcons/Education.js';
import '../../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/Admin.js';
import '../../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../../icons/InfoOverviewGroupIcons/Address.js';
import '../../icons/InfoOverviewGroupIcons/Salary.js';
import '../../icons/InfoOverviewGroupIcons/Gender.js';
import '../../icons/InfoOverviewGroupIcons/Translator.js';
import '../../icons/InfoOverviewGroupIcons/Birthday.js';
import '../../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../../icons/MiscGroupIcons/Link.js';
import '../../icons/MiscGroupIcons/History.js';
import '../../icons/MiscGroupIcons/Favorite.js';
import '../../icons/MiscGroupIcons/UnFavorite.js';
import '../../icons/MiscGroupIcons/ProductDocuments.js';
import '../../icons/MiscGroupIcons/Star.js';
import '../../icons/SocialMediaGroupIcons/Facebook.js';
import '../../icons/SocialMediaGroupIcons/Linkedin.js';
import '../../icons/SocialMediaGroupIcons/Twitter.js';
import '../../icons/SocialMediaGroupIcons/Zalo.js';
import '../../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../../icons/SocialMediaGroupIcons/Share.js';
import '../../icons/NavigationGroupIcons/Vertical.js';
import '../../icons/NavigationGroupIcons/More.js';
import '../../icons/NavigationGroupIcons/Close.js';
import '../../icons/NavigationGroupIcons/Expand.js';
import '../../icons/NavigationGroupIcons/Collapse.js';
import '../../icons/NavigationGroupIcons/Next.js';
import '../../icons/NavigationGroupIcons/Back.js';
import '../../icons/NavigationGroupIcons/ExternalLink.js';
import '../../icons/NavigationGroupIcons/RightArrow.js';
import '../../icons/AlertGroupIcons/SuccessIcon.js';
import '../../icons/AlertGroupIcons/CareerPath.js';
import '../../icons/AlertGroupIcons/Hot.js';
import '../../icons/AlertGroupIcons/Urgent.js';
import '../../icons/FormActionGroupIcons/Exchange.js';
import '../../icons/FormActionGroupIcons/AddTag.js';
import '../../icons/RewardsTypeGroupIcons/Hospital.js';
import '../../Images/DoubleTickIcon/index.js';
import '../../Images/BellIcon/index.js';
import '../../Images/AiIcon/index.js';
import '../../Images/MiniAiIcon/index.js';
import '../../icons/OrderManagementIcon.js';
import '../../Images/TwinkleLinearGradientIcon/index.js';
import SingleRadio from '../../SingleRadio/index.js';
import TextField from '../../TextField/index.js';
import useFloating from '../../hooks/useFloating/index.js';
import useClickAway from '../../hooks/useClickAway.js';
import '../../hooks/useMakeSearchable/types.js';
import '../../services/resumes/types.js';
import useDropdownAnimation from '../../hooks/useDropdownAnimation.js';
import MultiLevelCore from '../MultiLevelCore/index.js';
import { useMultiLevelContext } from '../store.js';
import { DropdownWrapper, DropdownTitle, SearchWrapper, SearchIconWrapper, Empty } from './styles.js';

function MultiLevelDropdown(_a) {
    var _b, _c;
    var renderReference = _a.renderReference;
    var _d = useMultiLevelContext(), dropdown = _d.dropdown, fieldValue = _d.fieldValue, fieldKey = _d.fieldKey, onChange = _d.onChange, values = _d.values, options = _d.options, floatingConfig = _d.floatingConfig, onBlur = _d.onBlur, translate = _d.translate;
    /**
     * State
     * */
    var _e = useState(false), show = _e[0], setShow = _e[1];
    var _f = useState(''), search = _f[0], setSearch = _f[1];
    var _g = useState(''), dropdownTitle = _g[0], setDropdownTitle = _g[1];
    var _h = useState(false), showBackButton = _h[0], setShowBackButton = _h[1];
    /**
     * Ref
     * */
    var dropdownRef = useRef({ back: function () { } });
    /**
     * Logic
     * */
    var handleToggleDropdown = function () {
        setShow(function (prevState) { return !prevState; });
    };
    /**
     * Hooks
     * */
    // Floating
    var _j = useFloating({
        placement: floatingConfig.placement || 'bottom-start',
        position: floatingConfig.position,
        config: __assign(__assign({}, floatingConfig), { detectHidden: true, offset: 4 })
    }), refs = _j.refs, context = _j.context, FloatingPortal = _j.FloatingPortal;
    // Click away
    useClickAway(function () {
        setShow(false);
        onBlur && onBlur();
    }, {
        nodeRefs: [refs.reference, refs.popup]
    });
    // Animation
    var _k = useDropdownAnimation(show, context.placement), animationStyles = _k.styles, isMounted = _k.isMounted;
    /**
     * Effects
     * */
    // Action when not show
    useEffect(function () {
        if (!show) {
            setSearch('');
        }
    }, [show]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { ref: refs.setReference }, renderReference({
            onToggle: handleToggleDropdown,
            isShow: show
        })),
        isMounted ? (React__default.createElement(FloatingPortal, { enable: floatingConfig.enablePortal },
            React__default.createElement("div", { ref: refs.setPopup, style: {
                    position: context.position,
                    top: context.y,
                    left: context.x,
                    display: context.isReferenceHidden ? 'none' : 'block',
                    width: dropdown.width ? dropdown.width : ((_b = refs.reference.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0,
                    zIndex: 1100
                } },
                React__default.createElement(DropdownWrapper, { style: animationStyles },
                    React__default.createElement(DropdownTitle, null,
                        showBackButton ? (React__default.createElement(Button, { isIcon: true, size: 'sm', isRounded: true, type: 'default', outline: 'none', tabIndex: -1, onClick: (_c = dropdownRef.current) === null || _c === void 0 ? void 0 : _c.back },
                            React__default.createElement(ArrowDownIcon, { style: { transform: 'rotate(90deg)' } }))) : null,
                        dropdownTitle !== '' ? dropdownTitle : dropdown.title),
                    dropdown.allowSearch ? (React__default.createElement(SearchWrapper, null,
                        React__default.createElement(TextField, { id: 'multi-level-search', value: search, onChange: setSearch, theme: 'normal', placeholder: dropdown.searchBoxPlaceholder, autoComplete: 'off', autoFocus: true, prefix: React__default.createElement(SearchIconWrapper, null,
                                React__default.createElement(SearchIcon, { height: 19 })) }))) : null,
                    React__default.createElement(MultiLevelCore, { enableKeyboardNavigation: show, ref: dropdownRef, values: values, onChangeTitle: setDropdownTitle, onShowBackButton: setShowBackButton, searchKeywords: search, options: options, onChange: onChange, fieldKey: fieldKey, fieldValue: fieldValue, maxHeight: dropdown.maxHeight || 0, onClearSearchKeywords: function () { return setSearch(''); }, renderItem: function (_a) {
                            var displayValue = _a.displayValue, isSelected = _a.isSelected, isHaveChild = _a.isHaveChild, isHover = _a.isHover;
                            return (React__default.createElement(SingleRadio, { id: displayValue, onChange: function () { }, label: displayValue, checked: isSelected, isLeftRadio: true, isHover: isHover, cssHover: false, decoration: isHaveChild ? (React__default.createElement(ArrowDownIcon, { style: { transform: 'rotate(-90deg)' }, width: 16, height: 16 })) : null }));
                        }, onClickLeafItem: function () {
                            setShow(false);
                        }, onClickEscape: function () {
                            setShow(false);
                        }, emptyNode: React__default.createElement(Empty, null, dropdown.emptyString || translate('No result')) }))))) : null));
}

export { MultiLevelDropdown as default };
//# sourceMappingURL=index.js.map
